var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('simple-header',{attrs:{"inverse":""}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("כוחו של המשחק")])]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('iframe',{attrs:{"src":"https://www.youtube.com/embed/8W1lXB5HViQ","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}]

export { render, staticRenderFns }